<div class="contact-component">
  <div class="contact-info">
    <div class="contact-info-data">
      <i class="material-icons ic-email">email</i>
      <a href="mailto:{{email}}" title="" class="blue">{{email}}</a>
    </div>
  </div>
</div>
